(function () {
  'use strict';

  /* @ngdoc object
   * @name languageDiscrepancy
   * @description
   *
   */
  angular
    .module('languageDiscrepancy', [
      'ui.router'
    ]);
}());
